__turbopack_context__.v({
  "newsletter": "styles-module-scss-module__LaYaca__newsletter",
  "newsletter__form": "styles-module-scss-module__LaYaca__newsletter__form",
  "newsletter__text": "styles-module-scss-module__LaYaca__newsletter__text",
  "section-newsletter": "styles-module-scss-module__LaYaca__section-newsletter",
});
